import React from "react";
import shared from "../shared.module.scss";
import styles from "./ProteinCalculator.module.scss";
import { InfoCard } from "../InfoCard";
import { SourceInfo } from "../SourceInfo";
import { FormActions } from "../FormActions";
import { Disclaimer } from "../../components/Disclaimer";
import { NumericField } from "../../../../secondary/NumericField/NumericField";
import { DISCLAIMER_TEXT } from "../constant";

export const RecommendedProteinView = ({ recommended, dailyProteinFood, setDailyProteinFood, errors, loading, message, onCalculate }) => {
  return (
    <div className={styles.section}>
      <InfoCard heading="Recommended Daily Protein Range" value={recommended.recommended} variant="emphasis" centered />

      <SourceInfo source={"Npaip guidelines"} webUrl={"https://www.pubmed/ncbi.gov"} />

      <hr className={shared.divider} />

      <NumericField
        id="daily-protein-food"
        label="Daily Protein Consumption From Food in grams"
        required
        suffix="gm"
        value={dailyProteinFood}
        onChange={setDailyProteinFood}
        error={errors.dailyProteinFood}
      />

      {message && <div className={`${shared.successBanner}`}>{message}</div>}

      <FormActions onClick={onCalculate} loading={loading} label="Calculate" />

      <Disclaimer>{DISCLAIMER_TEXT}</Disclaimer>
    </div>
  );
};
